import { useRef, type RefObject } from 'react';

export function useLatestRef<T>(data: T) {
  const dataRef = useRef<T>(data);
  dataRef.current = data;
  return dataRef;
}

type TLatestEnhancedRef<T extends object> = T & {
  ref: RefObject<T>;
};

export function useLatestReffable<T extends object = object>(data: T): TLatestEnhancedRef<T> {
  const dataRef = useLatestRef(data);
  return {
    ...data,
    ref: dataRef,
  };
}
